import { all } from 'redux-saga/effects';

import classificacoes from './classificacoes/saga';

export default all([classificacoes]);
